import {
  SAVE_SUBLIMIC_USER_SURVEY,
  SAVE_SUBLIMIC_STYLIST_DIAGNOSIS,
  RESET_SUBLIMIC_DIAGNOSIS,
  SAVE_SUBLIMIT_USER_DATA,
} from '../constants';

const defaultState = {
  email: null,
  locale: null,
  firstName: null,
  lastName: null,
  userSurveyResult: {
    result: [],
  },
  stylistDiagnosisResults: {
    result: {
      treatments: {},
      hairDiagnosis: {
        hearing: {
          Questions: [],
        },
        stylistDiagnosis: {
          Questions: [],
        },
      },
      scalpDiagnosis: {
        hearing: {
          Questions: [],
        },
        stylistDiagnosis: {
          Questions: [],
        },
      },
    },
  },
  sublimicDiagnosisResults: {
    result: {
      diagnosisResults: {},
      recommendedSalonSolutions: {},
      customizedSalonSolutions: {},
      recommendedHomeCareItems: {},
      customizedHomeCareItems: {},
    },
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SAVE_SUBLIMIC_USER_SURVEY:
      return {
        ...state,
        userSurveyResult: { result: action.payload },
      };
    // case SAVE_SUBLIMIC_STYLIST_DIAGNOSIS:
    //   return {
    //     ...state,
    //     stylistDiagnosis: action.payload,
    //   };
    case SAVE_SUBLIMIC_STYLIST_DIAGNOSIS:
      return {
        ...state,
        stylistDiagnosisResults: { result: action.payload },
      };
    case SAVE_SUBLIMIT_USER_DATA:
      return {
        ...state,
        email: action.payload.email,
        locale: action.payload.locale,
        firstName: action.payload.firstName,
      };
    case RESET_SUBLIMIC_DIAGNOSIS:
      return { ...defaultState };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/sublimicDiagnosis.js